export const movies = [
  {
    id: "la-la-land",
    title: "爱乐之城",
    englishTitle: "La La Land",
    genres: ["爱情片"],
    year: 2016,
    rating: 8.4,
    director: "达米恩·查泽雷",
    cast: ["瑞恩·高斯林", "艾玛·斯通"],
    duration: 128,
    tags: ["音乐爱情", "追梦", "复古浪漫"],
    synopsis:
      "在洛杉矶追梦的钢琴师塞巴斯蒂安与满怀演员梦的米娅相遇相爱，两人在理想与现实之间彼此成就又彼此错过。一段关于热爱、坚持与遗憾的都市恋曲，配乐与画面都美到让人屏息。",
    review: "适合在夜晚一起看，音乐响起时你们会不自觉握紧对方的手。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20cinematic%20movie%20poster%20illustration%20of%20a%20couple%20dancing%20under%20warm%20city%20lights%20at%20dusk%2C%20warm%20cream%20background%2C%20soft%20orange%20and%20dusty%20rose%20tones%2C%20cozy%20nostalgic%20atmosphere%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20print%20quality%20poster%20art&width=600&height=900&seq=poster-la-la-land&orientation=portrait",
  },
  {
    id: "flipped",
    title: "怦然心动",
    englishTitle: "Flipped",
    genres: ["爱情片"],
    year: 2010,
    rating: 9.1,
    director: "罗伯·莱纳",
    cast: ["玛德琳·卡罗尔", "卡兰·麦克奥利菲"],
    duration: 90,
    tags: ["青春", "初恋", "成长"],
    synopsis:
      "小姑娘朱莉从见到布莱斯的第一眼就怦然心动，而男孩却花了整个童年才学会抬头看她。两段视角交错的成长故事，讲透了喜欢一个人时那点笨拙又真诚的心意。",
    review: "看完会想起你们最初心动的那一刻，甜得刚刚好。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20poster%20illustration%20of%20two%20teenagers%20sitting%20on%20a%20tree%20branch%20at%20golden%20hour%2C%20cream%20beige%20background%2C%20soft%20orange%20and%20gentle%20rose%20tones%2C%20nostalgic%20summer%20afternoon%20mood%2C%20minimal%20elegant%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-flipped&orientation=portrait",
  },
  {
    id: "when-harry-met-sally",
    title: "当哈利遇上莎莉",
    englishTitle: "When Harry Met Sally",
    genres: ["爱情片", "喜剧片"],
    year: 1989,
    rating: 8.3,
    director: "罗伯·莱纳",
    cast: ["比利·克里斯托", "梅格·瑞恩"],
    duration: 96,
    tags: ["爱情喜剧", "日久生情", "经典对白"],
    synopsis:
      "哈利与莎莉从互相看不顺眼的旅伴，到多年后成为无话不谈的好友，再到终于承认彼此的心意。一部把男女之间那点小心思聊得明明白白的爱情喜剧经典。",
    review: "一边笑一边认命，说的就是你们俩。",
    poster:
      "https://readdy.ai/api/search-image?query=Charming%20retro%20movie%20poster%20illustration%20of%20a%20couple%20chatting%20in%20a%20warm%20autumn%20park%20with%20falling%20leaves%2C%20cream%20background%2C%20soft%20orange%20and%20muted%20rose%20tones%2C%20cozy%20vintage%20feel%2C%20clean%20minimal%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-harry-sally&orientation=portrait",
  },
  {
    id: "notting-hill",
    title: "诺丁山",
    englishTitle: "Notting Hill",
    genres: ["爱情片", "喜剧片"],
    year: 1999,
    rating: 8.0,
    director: "罗杰·米歇尔",
    cast: ["休·格兰特", "朱莉娅·罗伯茨"],
    duration: 124,
    tags: ["都市童话", "书店", "跨阶层爱情"],
    synopsis:
      "伦敦诺丁山一间小小旅行书店的老板，意外遇见了全世界最红的女明星。两个世界的人在最平凡的街巷里谈起了一场不平凡的恋爱。",
    review: "粉色基调的都市童话，适合周末慵懒的午后。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20urban%20movie%20poster%20illustration%20of%20a%20charming%20London%20street%20with%20a%20small%20bookshop%20and%20warm%20evening%20lights%2C%20cream%20background%2C%20soft%20orange%20and%20rose%20tones%2C%20cozy%20storybook%20atmosphere%2C%20elegant%20minimal%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-notting-hill&orientation=portrait",
  },
  {
    id: "about-time",
    title: "时空恋旅人",
    englishTitle: "About Time",
    genres: ["爱情片", "温情片"],
    year: 2013,
    rating: 8.8,
    director: "理查德·柯蒂斯",
    cast: ["多姆纳尔·格里森", "瑞秋·麦克亚当斯"],
    duration: 123,
    tags: ["时空", "家庭", "治愈"],
    synopsis:
      "拥有穿越时间能力的蒂姆，本想用这份天赋追到心爱的女孩，最后却发现真正值得珍惜的，是平凡生活里那些再普通不过的日子。",
    review: "看完想立刻抱住身边的人，说一句谢谢你陪着我。",
    poster:
      "https://readdy.ai/api/search-image?query=Heartwarming%20movie%20poster%20illustration%20of%20a%20couple%20walking%20hand%20in%20hand%20through%20a%20sunlit%20countryside%20meadow%2C%20warm%20cream%20background%2C%20soft%20orange%20and%20gentle%20rose%20tones%2C%20tender%20nostalgic%20mood%2C%20minimal%20elegant%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-about-time&orientation=portrait",
  },
  {
    id: "bouquet-of-love",
    title: "花束般的恋爱",
    englishTitle: "We Made a Beautiful Bouquet",
    genres: ["爱情片"],
    year: 2021,
    rating: 8.6,
    director: "土井裕泰",
    cast: ["菅田将晖", "有村架纯"],
    duration: 124,
    tags: ["日式纯爱", "兴趣相投", "现实"],
    synopsis:
      "两个错过末班车的年轻人，因为相同的书单、相同的音乐而一见如故，从校园走到社会，爱情也像一束花一样悄悄绽放又慢慢凋谢。",
    review: "真实到扎心，却让人更想好好珍惜眼前的人。",
    poster:
      "https://readdy.ai/api/search-image?query=Delicate%20Japanese%20style%20movie%20poster%20illustration%20of%20a%20young%20couple%20sharing%20earphones%20on%20a%20train%20platform%2C%20cream%20background%2C%20soft%20orange%20and%20pale%20rose%20tones%2C%20quiet%20melancholic%20warmth%2C%20minimal%20refined%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-bouquet-love&orientation=portrait",
  },
  {
    id: "love-letter",
    title: "情书",
    englishTitle: "Love Letter",
    genres: ["爱情片", "温情片"],
    year: 1995,
    rating: 8.9,
    director: "岩井俊二",
    cast: ["中山美穗", "丰川悦司"],
    duration: 117,
    tags: ["日式纯爱", "雪国", "暗恋"],
    synopsis:
      "一封寄往天国的信，意外牵出一段被时光掩埋的少年暗恋。皑皑白雪的小樽，藏着最干净也最让人心酸的心意。",
    review: "雪景美到窒息，适合冬天裹着毯子一起看。",
    poster:
      "https://readdy.ai/api/search-image?query=Gentle%20winter%20movie%20poster%20illustration%20of%20a%20lone%20figure%20in%20a%20snowy%20town%20under%20soft%20morning%20light%2C%20pale%20cream%20background%2C%20soft%20orange%20and%20muted%20rose%20accents%2C%20quiet%20nostalgic%20mood%2C%20minimal%20elegant%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-love-letter&orientation=portrait",
  },
  {
    id: "roman-holiday",
    title: "罗马假日",
    englishTitle: "Roman Holiday",
    genres: ["爱情片", "喜剧片"],
    year: 1953,
    rating: 9.1,
    director: "威廉·惠勒",
    cast: ["奥黛丽·赫本", "格利高里·派克"],
    duration: 118,
    tags: ["黑白经典", "公主", "一日游"],
    synopsis:
      "出逃的公主遇上落魄记者，在罗马街头度过了一天自由又甜蜜的假期。经典中的经典，赫本的短发与笑容惊艳了半个多世纪。",
    review: "老电影的魅力，在于它相信爱情最好的样子是成全。",
    poster:
      "https://readdy.ai/api/search-image?query=Timeless%20vintage%20movie%20poster%20illustration%20of%20a%20couple%20riding%20a%20scooter%20through%20sunny%20Rome%20streets%2C%20cream%20background%2C%20soft%20orange%20and%20faded%20rose%20tones%2C%20classic%20mid%20century%20charm%2C%20elegant%20minimal%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-roman-holiday&orientation=portrait",
  },
  {
    id: "your-name",
    title: "你的名字。",
    englishTitle: "Your Name",
    genres: ["爱情片", "动画片"],
    year: 2016,
    rating: 8.4,
    director: "新海诚",
    cast: ["神木隆之介", "上白石萌音"],
    duration: 106,
    tags: ["动画", "穿越", "唯美"],
    synopsis:
      "住在山间小镇的女孩与东京的少年在梦里交换了身体，命运的红线把他们一次次牵到一起。唯美画风与动人配乐让人久久无法平复。",
    review: "画面每一帧都能当壁纸，适合一起安静地看。",
    poster:
      "https://readdy.ai/api/search-image?query=Breathtaking%20anime%20movie%20poster%20illustration%20of%20two%20figures%20almost%20touching%20across%20a%20glowing%20twilight%20sky%2C%20warm%20cream%20and%20orange%20gradient%20background%2C%20soft%20rose%20accents%2C%20dreamy%20romantic%20atmosphere%2C%20minimal%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-your-name&orientation=portrait",
  },
  {
    id: "our-little-sister",
    title: "海街日记",
    englishTitle: "Our Little Sister",
    genres: ["温情片"],
    year: 2015,
    rating: 8.8,
    director: "是枝裕和",
    cast: ["绫濑遥", "长泽雅美"],
    duration: 128,
    tags: ["家庭", "日式生活", "四季"],
    synopsis:
      "镰仓四姐妹在同一屋檐下生活，庭院里的梅子树、海边的烟花、一餐一饭的琐碎，都被拍成了最温柔的日子。",
    review: "没什么大起伏，却让人心里暖很久。",
    poster:
      "https://readdy.ai/api/search-image?query=Serene%20Japanese%20family%20movie%20poster%20illustration%20of%20four%20women%20at%20a%20cozy%20seaside%20home%20with%20a%20plum%20tree%2C%20cream%20background%2C%20soft%20orange%20and%20gentle%20rose%20tones%2C%20peaceful%20daily%20life%20mood%2C%20minimal%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-our-little-sister&orientation=portrait",
  },
  {
    id: "little-forest",
    title: "小森林",
    englishTitle: "Little Forest",
    genres: ["温情片"],
    year: 2014,
    rating: 9.0,
    director: "森淳一",
    cast: ["桥本爱"],
    duration: 111,
    tags: ["田园", "美食", "治愈"],
    synopsis:
      "女孩市子回到山间小村，春种秋收、亲手做饭，用一蔬一饭慢慢与自己的内心和解。安静到极致的治愈之作。",
    review: "看完会想一起下厨做顿饭。",
    poster:
      "https://readdy.ai/api/search-image?query=Peaceful%20countryside%20movie%20poster%20illustration%20of%20a%20young%20woman%20cooking%20with%20fresh%20vegetables%20in%20a%20wooden%20kitchen%2C%20cream%20background%2C%20soft%20orange%20and%20muted%20rose%20tones%2C%20slow%20cozy%20farm%20life%20mood%2C%20minimal%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-little-forest&orientation=portrait",
  },
  {
    id: "spirited-away",
    title: "千与千寻",
    englishTitle: "Spirited Away",
    genres: ["动画片", "温情片"],
    year: 2001,
    rating: 9.4,
    director: "宫崎骏",
    cast: ["柊瑠美", "入野自由"],
    duration: 125,
    tags: ["动画", "奇幻", "成长"],
    synopsis:
      "少女千寻误入神灵的世界，为救回变成猪的父母，在汤屋做工并慢慢学会勇敢与坚韧。宫崎骏笔下最迷人的一场奇幻冒险。",
    review: "童年回忆，此刻一起重温刚刚好。",
    poster:
      "https://readdy.ai/api/search-image?query=Whimsical%20fantasy%20anime%20movie%20poster%20illustration%20of%20a%20small%20girl%20before%20a%20glowing%20magical%20bathhouse%20at%20night%2C%20warm%20cream%20and%20orange%20background%2C%20soft%20rose%20accents%2C%20enchanting%20storybook%20mood%2C%20minimal%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-spirited-away&orientation=portrait",
  },
  {
    id: "amelie",
    title: "天使爱美丽",
    englishTitle: "Amelie",
    genres: ["爱情片", "喜剧片"],
    year: 2001,
    rating: 8.7,
    director: "让-皮埃尔·热内",
    cast: ["奥黛丽·塔图"],
    duration: 122,
    tags: ["法式", "奇幻", "治愈"],
    synopsis:
      "巴黎女孩艾米丽决定悄悄帮助身边的人，给他们带去小小的惊喜，也在这一过程中遇见了属于自己的爱情。色彩浓郁，浪漫得不像话。",
    review: "法式色调太美，看完整个人都变得温柔。",
    poster:
      "https://readdy.ai/api/search-image?query=Playful%20French%20movie%20poster%20illustration%20of%20a%20young%20woman%20holding%20a%20small%20wrapped%20gift%20in%20a%20colorful%20Paris%20cafe%2C%20cream%20background%2C%20soft%20orange%20and%20rose%20tones%2C%20whimsical%20charming%20mood%2C%20minimal%20elegant%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-amelie&orientation=portrait",
  },
  {
    id: "legend-of-1900",
    title: "海上钢琴师",
    englishTitle: "The Legend of 1900",
    genres: ["温情片"],
    year: 1998,
    rating: 9.3,
    director: "朱塞佩·托纳多雷",
    cast: ["蒂姆·罗斯"],
    duration: 165,
    tags: ["音乐", "人生", "诗意"],
    synopsis:
      "出生在邮轮上的天才钢琴师1900，一生没有踏上过陆地，却用琴声看遍了世界的辽阔。关于选择、自由与孤独的诗意寓言。",
    review: "琴声响起时，安静得只剩下彼此的心跳。",
    poster:
      "https://readdy.ai/api/search-image?query=Poetic%20cinematic%20movie%20poster%20illustration%20of%20a%20pianist%20silhouette%20at%20a%20grand%20piano%20inside%20a%20grand%20old%20ship%2C%20warm%20cream%20background%2C%20soft%20orange%20and%20amber%20rose%20tones%2C%20melancholic%20elegant%20mood%2C%20minimal%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-legend-1900&orientation=portrait",
  },
  {
    id: "echoes-of-the-rainbow",
    title: "岁月神偷",
    englishTitle: "Echoes of the Rainbow",
    genres: ["温情片"],
    year: 2010,
    rating: 8.7,
    director: "罗启锐",
    cast: ["吴君如", "任达华"],
    duration: 117,
    tags: ["港片", "家庭", "怀旧"],
    synopsis:
      "上世纪六十年代的香港深水埗，做鞋的一家人苦中作乐，在生活的风浪里彼此扶持。岁月偷走了很多东西，也留下了最珍贵的情。",
    review: "朴素得让人掉泪，适合和爱人一起重温旧时光。",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20family%20movie%20poster%20illustration%20of%20a%20small%20old%20Hong%20Kong%20street%20with%20warm%20lantern%20lights%20and%20a%20family%2C%20cream%20background%2C%20soft%20orange%20and%20muted%20rose%20tones%2C%20sentimental%20sixties%20mood%2C%20minimal%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-echoes-rainbow&orientation=portrait",
  },
  {
    id: "up",
    title: "飞屋环游记",
    englishTitle: "Up",
    genres: ["动画片", "温情片", "喜剧片"],
    year: 2009,
    rating: 9.1,
    director: "彼特·道格特",
    cast: ["爱德华·阿斯纳"],
    duration: 96,
    tags: ["动画", "冒险", "一生之爱"],
    synopsis:
      "老爷爷卡尔用无数气球把房子带上天空，去完成与亡妻的约定，途中意外带上了一个小探险家。开篇十分钟就已经让人泪目。",
    review: "那句「谢谢你陪我冒险」，是给彼此最好的情书。",
    poster:
      "https://readdy.ai/api/search-image?query=Heartwarming%20animated%20movie%20poster%20illustration%20of%20a%20house%20lifted%20by%20hundreds%20of%20colorful%20balloons%20floating%20into%20a%20warm%20sunset%20sky%2C%20cream%20background%2C%20soft%20orange%20and%20rose%20tones%2C%20tender%20adventure%20mood%2C%20minimal%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-up&orientation=portrait",
  },
  {
    id: "zootopia",
    title: "疯狂动物城",
    englishTitle: "Zootopia",
    genres: ["动画片", "喜剧片"],
    year: 2016,
    rating: 9.2,
    director: "拜恩·霍华德",
    cast: ["金妮弗·古德温"],
    duration: 109,
    tags: ["动画", "搭档", "欢乐"],
    synopsis:
      "兔子警官朱迪与狐狸搭档尼克联手破案，在动物城里闹出一连串笑料与感动。轻松又聪明，笑点密集。",
    review: "适合一边吃零食一边笑到打滚的夜晚。",
    poster:
      "https://readdy.ai/api/search-image?query=Vibrant%20animated%20buddy%20movie%20poster%20illustration%20of%20a%20rabbit%20and%20a%20fox%20walking%20through%20a%20colorful%20modern%20city%2C%20warm%20cream%20background%2C%20soft%20orange%20and%20rose%20accents%2C%20playful%20cheerful%20mood%2C%20minimal%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-zootopia&orientation=portrait",
  },
  {
    id: "the-notebook",
    title: "恋恋笔记本",
    englishTitle: "The Notebook",
    genres: ["爱情片"],
    year: 2004,
    rating: 8.0,
    director: "尼克·卡萨维兹",
    cast: ["瑞恩·高斯林", "瑞秋·麦克亚当斯"],
    duration: 123,
    tags: ["深情", "久别重逢", "催泪"],
    synopsis:
      "一段跨越阶级与岁月的爱情，老人每天为失忆的爱人朗读他们年轻时的故事，只为唤回她哪怕一瞬间的记忆。",
    review: "准备好纸巾，也准备好握紧对方的手。",
    poster:
      "https://readdy.ai/api/search-image?query=Deeply%20romantic%20movie%20poster%20illustration%20of%20a%20couple%20in%20a%20rowboat%20on%20a%20still%20lake%20surrounded%20by%20autumn%20trees%2C%20cream%20background%2C%20soft%20orange%20and%20rose%20tones%2C%20tender%20timeless%20mood%2C%20minimal%20elegant%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-the-notebook&orientation=portrait",
  },
  {
    id: "the-terminal",
    title: "幸福终点站",
    englishTitle: "The Terminal",
    genres: ["喜剧片", "温情片"],
    year: 2004,
    rating: 8.8,
    director: "史蒂文·斯皮尔伯格",
    cast: ["汤姆·汉克斯"],
    duration: 128,
    tags: ["温暖", "陌生人善意", "机场"],
    synopsis:
      "因为祖国政变，东欧旅客维克多被迫滞留机场，语言不通的他在航站楼里顽强生活，用善良打动了每一个人。",
    review: "看完会觉得世界还是很温柔的。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20feel%20good%20movie%20poster%20illustration%20of%20a%20lonely%20traveler%20waiting%20in%20a%20bright%20airport%20terminal%20with%20warm%20lights%2C%20cream%20background%2C%20soft%20orange%20and%20rose%20accents%2C%20hopeful%20tender%20mood%2C%20minimal%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-the-terminal&orientation=portrait",
  },
  {
    id: "midnight-diner",
    title: "深夜食堂",
    englishTitle: "Midnight Diner",
    genres: ["温情片"],
    year: 2015,
    rating: 8.1,
    director: "松冈锭司",
    cast: ["小林薰"],
    duration: 119,
    tags: ["美食", "人生百态", "治愈"],
    synopsis:
      "只在深夜营业的小食堂里，老板用一道道家常菜，接住了一个又一个带着故事和疲惫的客人。食物与人心一起被慢慢焐热。",
    review: "适合深夜看完再一起吃碗热汤面。",
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20late%20night%20food%20movie%20poster%20illustration%20of%20a%20warm%20tiny%20Japanese%20diner%20with%20a%20steaming%20bowl%20on%20the%20counter%2C%20cream%20background%2C%20soft%20orange%20and%20rose%20tones%2C%20intimate%20healing%20mood%2C%20minimal%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-midnight-diner&orientation=portrait",
  },
  {
    id: "my-tomorrow-your-yesterday",
    title: "与君相恋100次",
    englishTitle: "My Tomorrow, Your Yesterday",
    genres: ["爱情片"],
    year: 2017,
    rating: 7.6,
    director: "月川翔",
    cast: ["miwa", "坂口健太郎"],
    duration: 116,
    tags: ["日式纯爱", "时光倒流", "催泪"],
    synopsis:
      "长谷川陆可以一次次回到过去，只为守护心爱的女孩日向葵海。可两人各自的时间却在朝着相反的方向流逝。",
    review: "青春片里的白月光，眼泪准备一下。",
    poster:
      "https://readdy.ai/api/search-image?query=Bittersweet%20youth%20romance%20movie%20poster%20illustration%20of%20a%20couple%20at%20a%20summer%20music%20festival%20under%20warm%20stage%20lights%2C%20cream%20background%2C%20soft%20orange%20and%20rose%20tones%2C%20nostalgic%20tender%20mood%2C%20minimal%20composition%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-my-tomorrow&orientation=portrait",
  },
  {
    id: "art-of-racing",
    title: "我在雨中等你",
    englishTitle: "The Art of Racing in the Rain",
    genres: ["温情片"],
    year: 2019,
    rating: 8.1,
    director: "西蒙·柯蒂斯",
    cast: ["米洛·文堤米利亚"],
    duration: 109,
    tags: ["狗狗", "陪伴", "治愈"],
    synopsis:
      "一只叫恩佐的狗用它的一生，见证了主人从赛车手到丈夫、到父亲的成长与跌宕。关于陪伴、忠诚与告别的温柔故事。",
    review: "养过宠物的人会哭到不行，慎入但值得。",
    poster:
      "https://readdy.ai/api/search-image?query=Heartfelt%20movie%20poster%20illustration%20of%20a%20golden%20dog%20sitting%20beside%20a%20man%20watching%20a%20warm%20sunset%20on%20a%20quiet%20country%20road%2C%20cream%20background%2C%20soft%20orange%20and%20rose%20tones%2C%20loyal%20tender%20mood%2C%20minimal%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-art-of-racing&orientation=portrait",
  },
  {
    id: "eat-drink-man-woman",
    title: "饮食男女",
    englishTitle: "Eat Drink Man Woman",
    genres: ["温情片", "喜剧片"],
    year: 1994,
    rating: 9.2,
    director: "李安",
    cast: ["郎雄", "杨贵媚"],
    duration: 124,
    tags: ["家庭", "美食", "父女"],
    synopsis:
      "老朱是国宴大厨，每周为三个女儿做一桌丰盛的晚餐，饭菜的热气里藏着一个家庭说不出口的牵绊与变化。",
    review: "一桌菜就是一个家，看完特别想回家吃饭。",
    poster:
      "https://readdy.ai/api/search-image?query=Rich%20family%20dinner%20movie%20poster%20illustration%20of%20a%20laden%20dining%20table%20with%20steaming%20Chinese%20dishes%20and%20warm%20light%2C%20cream%20background%2C%20soft%20orange%20and%20rose%20tones%2C%20warm%20family%20mood%2C%20minimal%20elegant%20layout%2C%20high%20detail%20poster%20art&width=600&height=900&seq=poster-eat-drink-man-woman&orientation=portrait",
  },
];